import { ClerkAppearanceTheme } from "@clerk/react-router/types";

export const clerkAppearance: ClerkAppearanceTheme = {
  variables: {
    borderRadius: "12px",
    // fontFamily: '"Jost", sans-serif',
    // fontFamilyButtons: '"Jost", sans-serif',
  },
  elements: {
    cardBox:
      "clerk-card-box clerk-brand-surface clerk-brand-shadow clerk-brand-border",
    modalContent:
      "clerk-modal-content clerk-brand-surface clerk-brand-shadow clerk-brand-border",
    navbar: "clerk-brand-subtle-border",
    pageScrollBox: "clerk-page-scroll",
    headerTitle: "clerk-header-title",
    headerSubtitle: "clerk-header-subtitle",
    socialButtonsBlockButton:
      "clerk-social-button clerk-brand-border clerk-brand-transition",
    socialButtonsBlockButtonText: "clerk-social-button-text",
    formButtonPrimary: "clerk-primary-button clerk-brand-transition",
    formFieldInput: "clerk-input clerk-brand-transition",
    formFieldLabel: "clerk-field-label",
    footerActionLink: "clerk-link",
    identityPreviewText: "clerk-identity-text",
    identityPreviewEditButton: "clerk-link",
    formFieldSuccessText: "clerk-success-text",
    formFieldErrorText: "clerk-error-text",
    alertText: "clerk-alert-text",
    alertClerkError: "clerk-alert clerk-alert-error",
    alertClerkWarning: "clerk-alert clerk-alert-warning",
    otpCodeFieldInput: "clerk-otp-input clerk-brand-transition",
    userButtonPopoverCard:
      "clerk-user-popover clerk-brand-surface clerk-brand-shadow clerk-brand-border",
    userButtonPopoverActionButton: "clerk-user-action clerk-brand-transition",
    userButtonPopoverActionButtonText: "clerk-user-action-text",
    userButtonPopoverFooter: "clerk-brand-subtle-border",
    userPreviewMainIdentifier: "clerk-user-main-identifier",
    userPreviewSecondaryIdentifier: "clerk-user-secondary-identifier",
    avatarBox: "clerk-avatar-box",
    userButtonAvatarBox: "clerk-avatar-box",
    userPreviewAvatarBox: "clerk-avatar-box",
    avatarImage: "clerk-avatar-image",
    userButtonAvatarImage: "clerk-avatar-image",
    userPreviewAvatarImage: "clerk-avatar-image",
    badge: "clerk-badge",
    footerItem: "d-none",
    rootBox: "signup-clerk-root",
  },
};
export const clerkAppearanceFlush: ClerkAppearanceTheme = {
  ...clerkAppearance,
  options: {
    elevation: "flush" as const,
  },
  elements: {
    ...clerkAppearance.elements,
    header: "d-none",
    footerItem: "d-none",
    // footer: "d-none",
    rootBox: "signup-clerk-root",
    // cardBox: "",
    // modalContent: "",
  },
};
